<script>
/*
  .q-item.q-router-link--active
     background: scale-color($primary, $lightness: 90%)
*/
import _ from 'lodash'
import { isSameRoute } from '@/router/utils.js'
import {
  // 组件
  QExpansionItem,
  QItem,
  QItemLabel,
  QItemSection,
  QIcon,
  QBadge,
  QList,
  QBtn,
  // 指令
  Ripple,
  QTooltip
} from 'quasar'

function createMenuNodeModels (menu) {
  const menuNodeModels = {}
  menu.forEach(node => {
    let props, attrs
    if (node.children?.length) {
      props = {
        label: node.text,
        icon: node.icon,
        headerClass: node.class ?? 'text-primary',
        defaultOpened: node.opened,
        // dense: menu.level > 0,
        // denseToggle: menu.level > 0,
        headerInsetLevel: node.level * 0.5
        // expandSeparator: true
        // switchToggleSide: menu.level > 0
      }
      attrs = {}
    } else {
      props = {
        to: node.link?.to,
        // dense: menu.level > 0,
        insetLevel: node.level * 0.5,
        active: false
      }
      attrs = {}

      if (node.external) {
        Object.assign(props, {
          to: undefined,
          clickable: true,
          tag: 'a'
        })

        attrs.href = node?.link.resolved.path
        attrs.target = '_blank'
      }
    }
    menuNodeModels[node.path] = {
      props,
      attrs
    }
  })
  return menuNodeModels
}

export default {
  name: 'ITreeMenu',
  props: {
    value: [String],
    whiteList: Array,
    closableNodePaths: Array
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  directives: {
    Ripple
  },
  computed: {
    whiteListSet () {
      return this.whiteList ? new Set(this.whiteList) : null
    },
    closableNodePathSet () {
      return this.closableNodePaths ? new Set(this.closableNodePaths) : null
    }
  },
  data () {
    return {
      menuNodeModels: createMenuNodeModels(this.$menu),
      activeMenuNode: undefined
    }
  },
  watch: {
    $route (route) {
      this.activateMenuNode(route)
    },
    value (node) {
      this.toMenuNode(node)
    }
  },
  render (h) {
    return h(QList, { staticClass: 'i-tree-menu' }, this.$menu.nodes.map(
      node => this.renderMenuNode(h, node, 1)
    ))
  },
  async mounted () {
    await this.toMenuNode(this.value)
    this.activateMenuNode(this.$route)
  },
  methods: {
    isNodeVisible (node) {
      if (this.whiteList) {
        if (this.whiteListSet.has(node.path)) {
          return true
        }
        const nodePath = node.path
        for (const whiteItemPath of this.whiteList) {
          if (whiteItemPath.startsWith(nodePath)) {
            if (whiteItemPath.length === nodePath.length || whiteItemPath[nodePath.length] === '.') {
              return true
            }
          } else if (nodePath.startsWith(whiteItemPath)) {
            if (nodePath.length === whiteItemPath.length || nodePath[whiteItemPath.length] === '.') {
              return true
            }
          }
        }
        return false
      } else {
        return true
      }
    },

    isNodeClosable (node) {
      return this.closableNodePathSet && this.closableNodePathSet.has(node.path)
    },

    activateMenuNode (route) {
      const oldMenuNode = this.activeMenuNode
      const newMenuNode = this.$menu.match(route)
      if (oldMenuNode !== newMenuNode) {
        if (oldMenuNode) {
          const oldMenuModel = this.menuNodeModels[oldMenuNode.path]
          if (oldMenuModel) {
            oldMenuModel.props.active = false
          } else {
            console.warn('未找到菜单:' + oldMenuNode.path)
          }
        }
        this.activeMenuNode = newMenuNode
        this.$emit('change', newMenuNode?.path)
        if (newMenuNode) {
          const newMenuModel = this.menuNodeModels[newMenuNode.path]
          if (newMenuModel) {
            newMenuModel.props.active = true
          } else {
            console.warn('未找到菜单:' + newMenuModel.path)
          }

          this.showMenuNode(this.$refs[newMenuNode.path])
        }
      }
    },

    showMenuNode (vmMenu) {
      if (vmMenu !== undefined && vmMenu !== this) {
        this.showMenuNode(vmMenu.$parent)
        vmMenu.show !== undefined && vmMenu.show()
      }
    },

    renderMenuNode (h, node, level) {
      const className = `level${level}`
      if (!this.isNodeVisible(node)) {
        return null
      }
      const nodeModel = this.menuNodeModels[node.path]
      if (node.children?.length) { // 目录
        return h(QExpansionItem, {
          ref: node.path,
          key: node.path,
          props: nodeModel.props,
          attrs: nodeModel.attrs,
          staticClass: 'non-selectable i-tree-menu-category',
          class: className,
          scopedSlots: {
            header () {
              const child = [
                h(QItemSection, [
                  h(QItemLabel, {
                    props: { lines: 1 }
                  }, [node.text || ''])
                ])
              ]
              node.icon && child.unshift(
                h(QItemSection, {
                  props: {
                    side: false,
                    avatar: true
                  }
                }, [
                  h(QIcon, {
                    staticClass: node.iconClass,
                    props: {
                      name: node.icon
                    }
                  })
                ])
              )
              return child
            }
          }
        }, node.children.map(item => this.renderMenuNode(h, item, 2)))
      }

      return h(QItem, {
        ref: node.path,
        key: node.path,
        props: nodeModel.props,
        attrs: nodeModel.attrs,
        staticClass: node.class ?? 'text-primary',
        directives: [{ name: 'ripple', value: true }]
      }, [
        // 图标
        node.icon === undefined ? null
          : h(QItemSection, {
            props: { avatar: true }
          }, [h(QIcon, { staticClass: node.iconClass, props: { name: node.icon } })]),

        // 文本
        h(QItemSection, {}, [h('div', {
          class: 'i-tree-menu-text'
        }, [node.text])]),

        // 关闭按钮
        h(QItemSection, {
          props: { side: true }
        }, [this.isNodeClosable(node) ? h('div', { attrs: { class: 'i-tree-menu-close' } }, [h(QBtn, {
          props: { icon: 'close', fabMini: true, size: 'xs', dense: true, round: true, flat: true, color: 'white' },
          on: {
            click: (event) => {
              event.preventDefault()
              this.$emit('node-close', node)
            }
          }
        }, [h(QTooltip, {
          scopedSlots: {
            default () {
              return '关闭已开页'
            }
          }
        })])]) : null]),

        // 角标
        node.badge === undefined ? null
          : h(QItemSection, {
            props: { side: true }
          }, [h(QBadge, [node.badge])])
      ])
    },

    async toMenuNode (node) {
      if (_.isString(node)) {
        node = this.$menu.nodesMap[node]
      }
      const location = node?.link?.to
      if (location) {
        const resolved = this.$router.resolve(location)
        if (!isSameRoute(resolved.route, this.$route)) {
          await this.$router.push(location)
        }
      }
    }
  }

}
</script>

<style lang="scss">
@import "@/styles/quasar.variables.scss";

.i-tree-menu {
  margin-top: 16px;
  .q-expansion-item--expanded > div > .q-item > .q-item__section--main {
    font-weight: bold;
  }
  // >a{
  //   font-size: 1.1em!important;
  // }
  .q-item {
    padding-left: 16px !important;
  }
  a.q-item {
    border-radius: 0 10px 10px 0;
    margin-right: 0px;
  }

  // a.q-item .q-icon{
  //   font-size: 20px;
  // }

  .q-item__section--avatar {
    min-width: unset;
  }

  .q-item__section--side > .q-icon {
    font-size: 24px;
  }

  .q-item--active {
    background: scale-color($color-action-active, $lightness: -30%);
  }
  .q-expansion-item__toggle-icon--rotated {
    color: white;
  }
}

.i-tree-menu-close {
  position: absolute;
  right: 5px;
}
.i-tree-menu-text {
  font-size: 1.1rem;
}
.i-tree-menu-category {
  font-size: 1.1rem;
}
.level1 .q-expansion-item__content {
  background-color: #1E4553 !important;
  .q-item {
    padding-left: 55px !important;
  }
}
.level2 .q-expansion-item__content {
  background-color: #1F3F4B !important;
  .q-item {
    padding-left: 70px !important;
  }
}
</style>
